import React from "react";
import ReactDOM from "react-dom/client";
import { MotionConfig } from "framer-motion";
import App from "@/App.tsx";
import AuthRedirect from "@/pages/AuthRedirect";
import { msalInstance } from "@/lib/auth";
import { initTelemetry } from "@/lib/telemetry";
import "@/index.css";

async function bootstrap() {
  // Before anything else that can fail, so a bootstrap error is itself reported.
  // Notably before MSAL: a sign-in that never returns from the redirect is one of
  // the failures this exists to catch, and initialising after it would miss
  // exactly that case.
  initTelemetry();

  const root = ReactDOM.createRoot(document.getElementById("root")!);

  // Dedicated redirect landing route: handles both popup and redirect auth
  // responses without booting the full app shell (standalone or embed).
  if (window.location.pathname === "/auth-redirect") {
    root.render(
      <React.StrictMode>
        <AuthRedirect />
      </React.StrictMode>,
    );
    return;
  }

  // MSAL v3 requires initialize() before any interactive/silent call, and
  // handleRedirectPromise() must run on load to complete a redirect sign-in.
  // Never brick the shell if bootstrap fails — the app's own auth gates then
  // surface the unauthenticated state.
  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
  } catch (e) {
    console.error("MSAL bootstrap failed", e);
  }

  // `reducedMotion="user"` makes every framer-motion animation follow the OS
  // "Reduce motion" setting. It drops transform and layout transitions but keeps
  // opacity ones, which is the behaviour we want for the chat-history row: the
  // delete button still appears, it just stops sliding 40px to get there, so no
  // affordance is lost (MA-213).
  //
  // At the root rather than around the one component that uses framer-motion
  // today, so anything added later inherits it instead of having to remember.
  root.render(
    <React.StrictMode>
      <MotionConfig reducedMotion="user">
        <App />
      </MotionConfig>
    </React.StrictMode>,
  );
}

bootstrap();
